/**
 * Cada cuánto se vuelve a pedir lo que se está mirando.
 *
 * No es `refetchInterval` (FR-012 lo prohíbe): es una elección de QUIEN MIRA
 * (spec 015 · FR-030, spec 054). Se para si la pestaña no se ve. El SSE no
 * atraviesa el calendario. Cinco segundos contra EasyAppointments, con
 * cientos de negocios, no es un refresco: es un ataque. Treinta es el
 * defecto; quince, el suelo.
 *
 * La clave sigue llamándose `calendario:` para no olvidar la elección
 * que ya estaba guardada.
 */
export const CLAVE_REFRESCO = 'calendario:autoRefresco'

/**
 * Lo que el intervalo recarga, y solo si esa pantalla está abierta.
 * Spec 054 · FR-002. Altas, horarios y catálogo no entran.
 */
export const CLAVES_REFRESCO = [
    ['business'],
    ['pulso-trends'],
    ['elevadas'],
    ['counter'],
    ['calendario'],
    ['vacaciones'],
] as const

export const INTERVALOS_REFRESCO = [
    { ms: 0, etiqueta: 'Manual' },
    { ms: 15_000, etiqueta: '15 s' },
    { ms: 30_000, etiqueta: '30 s' },
    { ms: 60_000, etiqueta: '1 min' },
] as const

export const DEFECTO_REFRESCO_MS = 30_000

export function leerRefresco(): number {
    try {
        const v = localStorage.getItem(CLAVE_REFRESCO)
        if (v === null) return DEFECTO_REFRESCO_MS
        const n = Number(v)
        if (INTERVALOS_REFRESCO.some((i) => i.ms === n)) return n
    } catch {
        /* modo privado */
    }
    return DEFECTO_REFRESCO_MS
}

export function escribirRefresco(ms: number): void {
    try {
        localStorage.setItem(CLAVE_REFRESCO, String(ms))
    } catch {
        /* modo privado */
    }
}
